import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { useGetVehicleModels } from "../../../queries/useGetVehicleModels";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { ComboBox } from "../../../ui/ComboBox/ComboBox";
import { Input } from "../../../ui/Input/Input";
import { Spinner } from "../../../ui/Spinner";
import { CarIcon } from "../../../ui/icons/CarIcon";
import { ChevronRightIcon } from "../../../ui/icons/ChevronRightIcon";
import { usePlacement } from "./usePlacement";

export const ModelInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const { data, isLoading, selectedOptionLabel } = useGetVehicleModels();
  const [language] = useLanguage();
  const [{ vehicleManufacturerName, vehicleModelName }, { setModel }] =
    useSearchForm();

  const open = !vehicleModelName && !!data;

  return (
    <ComboBox
      onSelectOption={(option): void => {
        const nextVehicleModelName =
          option?.data.vehicleModelName[language === "fr" ? "fr" : "en"] ||
          null;
        const nextVehicleModelClassId = Number(option?.data.vehicleModelClassId)
          ? option!.data.vehicleModelClassId
          : null;
        setModel(nextVehicleModelName, nextVehicleModelClassId);
      }}
      id="model-combo"
      open={open}
      options={data || []}
      placement={usePlacement()}
    >
      <Input
        after={isLoading ? <Spinner /> : <ChevronRightIcon />}
        aria-label="selectedModel"
        before={<CarIcon />}
        disabled={!vehicleManufacturerName}
        name="model"
        placeholder={t("searchForm.selectModel")}
        readOnly={!data}
        value={selectedOptionLabel || ""}
      />
    </ComboBox>
  );
};
